var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"projects"},[(_vm.items.length > 0)?_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-row',_vm._l((_vm.items),function(item,index){return _c('b-col',{key:index,staticClass:"p-xl-2 p-4",attrs:{"xl":"6"}},[_c('project-tile',{attrs:{"item":item}})],1)}),1)],1)],1)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }